import React from 'react';
import clsx from 'clsx';
import {CookieChecker, Header, WhatsappButton} from '../../components';

import styles from './Main.module.scss';

const Main = (props) => {
  const {children, onSignOutAction, disabledWhatsapp = false, ...rest} = props;
  const headerProps = {...rest, onSignOut: onSignOutAction};

  return (
    <div className="viewport-container-1200">
      <Header {...headerProps}/>
      <div className={clsx(styles.mainLayout, "h-full overflow-auto")}>
        {children}
      </div>
      <div className="h-6 bg-primary w-full hidden sm:block"/>
      <CookieChecker/>
      {!disabledWhatsapp && <WhatsappButton/>}
    </div>
  );
};

export default Main;
